import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../../lib/utils';
import { SectionHeaderProps } from './types';

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  subtitle,
  align = 'left',
  className,
  animate = false
}) => {
  const headerContent = (
    <div className={cn(
      'mb-6',
      align === 'center' && 'text-center',
      className
    )}>
      <h2 className={cn(
        'text-3xl md:text-4xl font-bold text-slate-900',
        align === 'center' && 'mx-auto'
      )}>
        {title}
      </h2>
      {subtitle && (
        <div className={cn(
          'mt-4 text-lg text-slate-600',
          align === 'center' && 'max-w-3xl mx-auto'
        )}>
          {subtitle}
        </div>
      )}
    </div>
  );

  if (animate) {
    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        {headerContent}
      </motion.div>
    );
  }

  return headerContent;
};

export default SectionHeader;